import style from "./Chart.module.css";

export default function Chart() {
  return (
    <div
      id="chart"
      className="relative w-full h-full pt-14 2xl:pt-24 text-white bg-secondary"
    >
      {/* <div className="absolute -right-16 top-0">
        <img src="/images/chartBg1.png" alt="circle" width={600} height={600} />
      </div> */}
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] overflow-hidden">
        <div className="absolute left-0 top-0 w-full h-full z-0">
          <img
            className="w-full h-full object-contain mt-12 3xl:mt-24"
            alt="background"
            src="/images/chart_bg.png"
            width={1768}
            height={663}
          />
        </div>
        <div className="relative w-full h-fit max-w-[1600px] mx-auto lg:flex items-start gap-5">
          <div className="relative w-fit h-fit bg-black bg-opacity-50 rounded-full py-2 px-5 mx-auto lg:mx-0">
            <h4 className="xl:text-[30px]">
              부산&nbsp;경남&nbsp;문의&nbsp;해결율&nbsp;
              <span className="gmedium">(%)</span>
            </h4>
          </div>
          <div className="relative w-full lg:w-fit h-fit pt-3 lg:pt-2">
            <h5 className="text-base sm:text-xl xl:text-2xl">
              해결&nbsp;:&nbsp;두&nbsp;번&nbsp;보지않도록&nbsp;깔끔하게&nbsp;해결된&nbsp;현장
            </h5>
            <div className="flex">
              <h4 className="xl:text-[30px] hidden lg:block">
                　　&nbsp;&nbsp;
              </h4>
              <p className="text-md md:text-lg lg:text-xl !text-white gmedium">
                고객님의&nbsp;요구사항을&nbsp;정확하게&nbsp;파악하여
                문제의&nbsp;근본이&nbsp;해결될&nbsp;수&nbsp;있도록&nbsp;도와드립니다.
              </p>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-up"
          className="relative w-full h-fit max-w-[1600px] mx-auto  pt-10 lg:pt-16 3xl:pt-32 xl:px-24 grid grid-cols-4 items-end justify-items-center gap-5 z-10"
        >
          <div className="relative w-fit h-fit">
            <img
              className="hidden lg:block !relative w-full h-auto max-w-[220px] object-contain"
              alt="chart1"
              src={"/images/chart1.png"}
              width={302}
              height={543}
            />
            <img
              className="block lg:hidden !relative w-full h-auto max-w-[60px] object-contain mx-auto"
              alt="chart1"
              src={"/images/chart1_mo.png"}
              width={202}
              height={537}
            />
            <ChartLabel color="bg-[#0E51A0]" txt="A업체" />
          </div>
          <div className="relative w-fit h-fit">
            <div className={`${style.loader} ${style.loader_2}`}></div>
            <img
              className="hidden lg:block !relative w-full h-auto max-w-[220px] object-contain"
              alt="chart2"
              src={"/images/chart2.png"}
              width={302}
              height={692}
            />
            <img
              className="block lg:hidden !relative w-full h-auto max-w-[60px] object-contain mx-auto"
              alt="chart1"
              src={"/images/chart2_mo.png"}
              width={202}
              height={685}
            />
            <ChartLabel color="bg-[#DD2424]" txt="몽땅" />
          </div>
          <div className="relative w-fit h-fit">
            <img
              className="hidden lg:block !relative w-full h-auto max-w-[220px] object-contain"
              alt="chart3"
              src={"/images/chart3.png"}
              width={302}
              height={625}
            />
            <img
              className="block lg:hidden !relative w-full h-auto max-w-[60px] object-contain mx-auto"
              alt="chart1"
              src={"/images/chart3_mo.png"}
              width={202}
              height={617}
            />
            <ChartLabel color="bg-[#479434]" txt="C업체" />
          </div>
          <div className="relative w-fit h-fit">
            <img
              className="hidden lg:block !relative w-full h-auto max-w-[220px] object-contain"
              alt="chart4"
              src={"/images/chart4.png"}
              width={302}
              height={659}
            />
            <img
              className="block lg:hidden !relative w-full h-auto max-w-[60px] object-contain mx-auto"
              alt="chart1"
              src={"/images/chart4_mo.png"}
              width={202}
              height={651}
            />
            <ChartLabel color="bg-[#FFB101]" txt="D업체" />
          </div>
        </div>
      </div>
      <div className="relative w-full h-fit -mt-44 lg:-mt-60 2xl:-mt-96 z-0">
        <img
          className="!relative w-full h-auto min-h-[200px] md:min-h-[230px] object-cover object-center"
          alt="bottom"
          src={"/images/chart_bottom.png"}
          width={2558}
          height={527}
        />
      </div>
    </div>
  );
}

function ChartLabel({ color, txt }: { color: string; txt: string }) {
  return (
    <div
      className={`relative w-full lg:w-32 h-fit ${color} text-center p-1 lg:rounded-full mt-5 rounded-md`}
    >
      <p>{txt}</p>
    </div>
  );
}
